import { render } from "./DeleteUser.vue?vue&type=template&id=2aeb3746&scoped=true"
import script from "./DeleteUser.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteUser.vue?vue&type=script&setup=true&lang=js"

import "./DeleteUser.vue?vue&type=style&index=0&id=2aeb3746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aeb3746"],['__file',"src/components/DeleteUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2aeb3746"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2aeb3746', __exports__)) {
    api.reload('2aeb3746', __exports__)
  }
  
  module.hot.accept("./DeleteUser.vue?vue&type=template&id=2aeb3746&scoped=true", () => {
    api.rerender('2aeb3746', render)
  })

}


export default __exports__